/** Owned model-library behavior; all captured DOM knowledge lives in the adapter. */
export function mountModelLibrary({adapter, registry, window, readinessTimeout = 30000, onReady, onDispose}) {
  let disposed = false;
  let ready = false;
  let frame = null;
  let openOnReady = new URLSearchParams(window.location.search).has('models');

  const timeout = window.setTimeout(() => {
    if (ready || disposed) return;
    dispose();
    const error = new Error(`The captured editor did not become ready within ${readinessTimeout / 1000} seconds`);
    window.console.error('[Mockup Studio]', error);
    window.dispatchEvent(new window.CustomEvent('studio:local-error', {detail: {message: error.message}}));
  }, readinessTimeout);

  function sync() {
    frame = null;
    if (disposed || !adapter.ready) return;
    if (!ready) {
      ready = true;
      window.clearTimeout(timeout);
      onReady?.(schedule);
    }
    const selected = registry.resolveSelection(adapter.selectedLabel);
    adapter.setNativeFinish(selected?.available === true && selected.adaptedFromApple === true);
    adapter.syncModelsButton();
    adapter.syncMenu(registry);
    if (openOnReady) {
      openOnReady = false;
      const url = new URL(window.location.href);
      url.searchParams.delete('models');
      window.history.replaceState(window.history.state, '', url);
      adapter.toggleModels();
    }
  }

  function schedule() {
    if (!disposed && frame === null) frame = window.requestAnimationFrame(sync);
  }

  const stopObserving = adapter.observe(schedule);
  const initialPath = window.location.pathname;
  function onNavigation() {
    if (window.location.pathname !== initialPath) dispose();
    else schedule();
  }
  window.addEventListener('pagehide', dispose, {once: true});
  window.addEventListener('popstate', onNavigation);
  schedule();

  function dispose() {
    if (disposed) return;
    disposed = true;
    stopObserving();
    window.clearTimeout(timeout);
    if (frame !== null) window.cancelAnimationFrame(frame);
    window.removeEventListener('pagehide', dispose);
    window.removeEventListener('popstate', onNavigation);
    onDispose?.();
    adapter.dispose();
  }
  return {dispose, get ready() { return ready; }, get disposed() { return disposed; }};
}
